<app-alerts></app-alerts>

<div class="row">
	<div class="col-12">

		<!-- Period first: every figure and both tables below describe the same
		     window, so there is never a doubt what a number covers. -->
		<nb-card>
			<nb-card-body>
				<div class="periodRow">
					<button nbButton size="small" *ngFor="let p of periods"
						[status]="period === p.value ? 'primary' : 'basic'"
						(click)="setPeriod(p.value)">{{p.label}}</button>
				</div>

				<div class="totalsRow">
					<div class="totalBox">
						<div class="totalLabel">Продано</div>
						<div class="totalValue">{{(totals?.sold || 0) | number:'1.2'}} грн</div>
					</div>
					<div class="totalBox">
						<div class="totalLabel">Комісія сервісу</div>
						<div class="totalValue">{{(totals?.fee || 0) | number:'1.2'}} грн</div>
					</div>
					<div class="totalBox">
						<div class="totalLabel">Комісія банку</div>
						<div class="totalValue">{{(totals?.bank || 0) | number:'1.2'}} грн</div>
					</div>
					<div class="totalBox">
						<div class="totalLabel">На рахунок ФОП</div>
						<div class="totalValue accent">{{(totals?.net || 0) | number:'1.2'}} грн</div>
					</div>
					<div class="totalBox">
						<div class="totalLabel">Платежів</div>
						<div class="totalValue">{{totals?.count || 0}}</div>
					</div>
				</div>
				<div class="totalsNote">Гроші за продажі банк зараховує напряму на рахунок вашого ФОП. «На рахунок ФОП» — це оплачена сума мінус комісія сервісу за вашим тарифом і комісія банку за прийом платежу; повернення покупцям уже враховані.</div>
			</nb-card-body>
		</nb-card>


		<!-- Which content earns. Opening a row filters the register below to that
		     one item, which is what "sales for this stream" actually means. -->
		<nb-card>
			<nb-card-header style="border-bottom:0 !important;">Продажі за контентом</nb-card-header>
			<nb-card-body style="margin:0 !important; padding:0 !important;">

				<table class="table table-hover stack" *ngIf="byContent?.length">
					<thead>
					<tr>
						<td>Назва</td>
						<td>Тип</td>
						<td class="num">Платежів</td>
						<td class="num">Продано</td>
						<td class="num">Комісія сервісу</td>
						<td class="num">Комісія банку</td>
						<td class="num">На рахунок ФОП</td>
						<td></td>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let c of byContent">
						<td class="first">{{c.title}}</td>
						<td class="muted" data-label="Тип">{{kindLabel(c.kind)}}</td>
						<td class="num" data-label="Платежів">{{c.count}}</td>
						<td class="num" data-label="Продано">{{c.sold | number:'1.2'}} грн</td>
						<td class="num" data-label="Комісія сервісу">{{c.fee | number:'1.2'}} грн</td>
						<td class="num" data-label="Комісія банку">{{c.bank | number:'1.2'}} грн</td>
						<td class="num" data-label="На рахунок ФОП"><b>{{c.net | number:'1.2'}} грн</b></td>
						<td class="num action">
							<a href="javascript:;" (click)="filterByContent(c)"
								*ngIf="contentFilter?.id !== c.id">Показати платежі</a>
							<a href="javascript:;" (click)="clearContentFilter()"
								*ngIf="contentFilter?.id === c.id">Показати всі</a>
						</td>
					</tr>
					</tbody>
				</table>

				<div class="emptyRow" *ngIf="!byContent?.length">За цей період продажів не було.</div>

			</nb-card-body>
		</nb-card>


		<nb-card>
			<nb-card-header style="border-bottom:0 !important;">
				Платежі
				<span class="filterNote" *ngIf="contentFilter"> — {{contentFilter.title}}
					<a href="javascript:;" (click)="clearContentFilter()">скинути</a></span>
			</nb-card-header>
			<nb-card-body style="margin:0 !important; padding:0 !important;">

				<div class="filtersRow">
					<nb-select size="small" [selected]="kind" (selectedChange)="setKind($event)">
						<nb-option value="all">Усі типи</nb-option>
						<nb-option value="stream">Трансляції</nb-option>
						<nb-option value="video">Відео</nb-option>
						<nb-option value="playlist">Плейлисти</nb-option>
						<nb-option value="donate">Донати</nb-option>
					</nb-select>

					<input nbInput fieldSize="small" placeholder="Пошук за email або кодом"
						[(ngModel)]="query" (keyup.enter)="applySearch()" />
					<button nbButton size="small" status="basic" (click)="applySearch()">Знайти</button>
					<button nbButton size="small" status="basic" *ngIf="query" (click)="clearSearch()">Скинути</button>
				</div>

				<table class="table table-hover stack" *ngIf="payouts?.length">
					<thead>
					<tr>
						<td>Дата</td>
						<td>Назва</td>
						<td>Тип</td>
						<td>Покупець</td>
						<td>Код</td>
						<td class="num">Оплачено</td>
						<td class="num">Комісія сервісу</td>
						<td class="num">Комісія банку</td>
						<td class="num">На рахунок ФОП</td>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let p of payouts" [class.reversedRow]="p.reversed">
						<td class="nowrap first">{{p.date | date:'dd.MM.yyyy HH:mm'}}</td>
						<td data-label="Назва">{{p.title}}</td>
						<td class="muted" data-label="Тип">{{kindLabel(p.kind)}}</td>
						<td class="small" data-label="Покупець">{{p.buyer || '—'}}</td>
						<td class="small mono" data-label="Код">{{p.code || '—'}}</td>
						<td class="num nowrap" data-label="Оплачено">{{p.sold | number:'1.2'}} грн</td>
						<td class="num nowrap" data-label="Комісія сервісу">{{p.fee | number:'1.2'}} грн</td>
						<td class="num nowrap" data-label="Комісія банку">{{p.bank | number:'1.2'}} грн</td>
						<td class="num nowrap" data-label="На рахунок ФОП">
							<b *ngIf="!p.reversed">{{(p.net - p.refunded) | number:'1.2'}} грн</b>
							<span class="refundTag" *ngIf="p.reversed">Повернено покупцю</span>
							<div class="refundNote" *ngIf="!p.reversed && p.refunded > 0">повернено {{p.refunded | number:'1.2'}} грн</div>
						</td>
					</tr>
					</tbody>
				</table>

				<div class="emptyRow" *ngIf="!payouts?.length && !loading">
					{{ query || contentFilter || kind !== 'all' ? 'За цим фільтром платежів немає.' : 'Платежів ще не було.' }}
				</div>

				<div class="pagerRow" *ngIf="pages > 1">
					<button nbButton size="small" status="basic" [disabled]="page <= 1" (click)="goPage(page - 1)">Назад</button>
					<span class="pagerText">Сторінка {{page}} з {{pages}}</span>
					<button nbButton size="small" status="basic" [disabled]="page >= pages" (click)="goPage(page + 1)">Далі</button>
				</div>

			</nb-card-body>
		</nb-card>

	</div>
</div>
